import FilterTextFormatter from '@/components/cell-renderers/FilterTextFormatter';
import ProgramTypeCellRenderer from '@/components/cell-renderers/ProgramTypeCellRenderer';
import RemoveEntityCellRenderer from '@/components/cell-renderers/RemoveEntityCellRenderer';
import AgGridLayout from '@/components/wrappers/layouts/AgGridLayout';
import { useGetModulesData } from '@/hooks/AllCustomHooks';
import { IMainContext, INegativeKeywordsData, IValueBoolean } from '@/ts/common-types';
import { customFilterOptions, mainContext } from '@/ts/constants';
import { negativeKeywordsSelectionChanged, titleCase } from '@/ts/utils';
import { ValueFormatterParams } from 'ag-grid-community';
import { useContext, useMemo } from 'react'
import { useSelector } from 'react-redux';

const ExistingNegativeKeywords = () => {

    const { setExistingNegKwsGridApi, cerbosPermissions } =
        useContext<IMainContext>(mainContext);

    const existingNegKwsData = useSelector(
        (state: INegativeKeywordsData) => state.existingNegKwsData.value
    );

    const existingNegKwsLoading = useSelector(
        (state: { existingNegKwsLoading: IValueBoolean }) =>
            state.existingNegKwsLoading.value
    );

    const gridParams = useGetModulesData({ type: "grid-params" });

    const columnDefs = useGetModulesData({
        type: "columns",
        colDefs: [
            {
                field: "keyword_name",
                headerName: "Keyword",
                sort: "asc",
                minWidth: 300,
                maxWidth: 400,
                filter: "agTextColumnFilter",
                filterParams: {
                    filterOptions: customFilterOptions["text"],
                },
                checkboxSelection: true,
                pinned: "left",
                lockPinned: true,
                cellClass: "lock-pinned",
                tooltipField: "custom_search_term",
                valueFormatter: (params: ValueFormatterParams) =>
                    titleCase(params.value),
                cellRendererParams: {
                    hasPinnedColumnValue: true,
                    pinnedColumnValue: "Total",
                },
            },
            {
                field: "",
                headerName: "",
                maxWidth: 100,
                pinned: "left",
                lockPinned: true,
                cellRenderer: RemoveEntityCellRenderer,
                filter: false,
                cellRendererParams: {
                    hasPinnedColumnValue: false,
                    isModalComponent: true,
                },
            },
            {
                field: "program_type",
                headerName: "Ad Type",
                filter: "agSetColumnFilter",
                cellStyle: { whiteSpace: "normal" },
                lockPinned: true,
                cellClass: ["lock-pinned"],
                maxWidth: gridParams["program_type"].maxWidth,
                minWidth: gridParams["program_type"].minWidth,
                cellRenderer: ProgramTypeCellRenderer,
                cellRendererParams: {
                    hasPinnedColumnValue: false,
                },
                filterParams: {
                    valueFormatter: FilterTextFormatter
                },
            },
            {
                field: "match_type",
                headerName: "Match Type",
                valueFormatter: (params: ValueFormatterParams) =>
                    titleCase(params.value),
                filter: "agSetColumnFilter",
                filterParams: {
                    showTooltips: true,
                },
                cellRendererParams: {
                    hasPinnedColumnValue: false,
                },
            },
            {
                field: "campaign_name",
                headerName: "Campaign Name",
                filter: "agTextColumnFilter",
                minWidth: 320,
                maxWidth: 350,
                cellRendererParams: {
                    hasPinnedColumnValue: false,
                },
                filterParams: {
                    filterOptions: customFilterOptions["text"],
                },
            },
            {
                field: "ad_group_name",
                headerName: "Ad Group",
                filter: "agTextColumnFilter",
                minWidth: 320,
                maxWidth: 350,
                cellRendererParams: {
                    hasPinnedColumnValue: false,
                },
            },
            {
                field: "record_type",
                headerName: "Keyword Type",
                valueFormatter: (params: ValueFormatterParams) =>
                    titleCase(params.value),
                cellRendererParams: {
                    hasPinnedColumnValue: false,
                },
                filter: "agSetColumnFilter",
            },
        ],
    });

    return (
        <div
            className="wrapper"
            style={{
                flex: "1 1 0",
                width: "100%",
                maxHeight: "calc(100% - 92px)",
            }}
        >
            <div
                id="negative-keywords-grid"
                className="ag-theme-alpine"
                style={{
                    height: "calc(100vh - 150px)",
                    width: "100%",
                }}
            >
                <AgGridLayout
                    rowData={existingNegKwsData}
                    columnDefs={columnDefs}
                    setGridApi={setExistingNegKwsGridApi}
                    onSelectionChanged={negativeKeywordsSelectionChanged}
                    loading={existingNegKwsLoading}
                    isTotalRowsReq={true}
                />
            </div>
        </div>
    );
}

export default ExistingNegativeKeywords